<template>
  <div class="box">
    <banner title="新闻资讯" :img="sty" />
    <div>
      <img :src="getImgUrl(showInfo.imgUrl)" alt="" />
      <div>
        <p>{{ showInfo.name }}</p>
        <span>
          君不见，黄河之水天上来，奔流到海不复回。
          君不见，高堂明镜悲白发，朝如青丝暮成雪。
          人生得意须尽欢，莫使金樽空对月。 天生我材必有用，千金散尽还复来。
          烹羊宰牛且为乐，会须一饮三百杯。 岑夫子，丹丘生，将进酒，杯莫停。
          与君歌一曲，请君为我倾耳听。 钟鼓馔玉不足贵，但愿长醉不复醒。
          古来圣贤皆寂寞，惟有饮者留其名。 陈王昔时宴平乐，斗酒十千恣欢谑。
          主人何为言少钱，径须沽取对君酌。
          五花马，千金裘，呼儿将出换美酒，与尔同销万古愁。
          君不见，黄河之水天上来，奔流到海不复回。
          君不见，高堂明镜悲白发，朝如青丝暮成雪。
          人生得意须尽欢，莫使金樽空对月。 天生我材必有用，千金散尽还复来。
          烹羊宰牛且为乐，会须一饮三百杯。 岑夫子，丹丘生，将进酒，杯莫停。
          与君歌一曲，请君为我倾耳听。 钟鼓馔玉不足贵，但愿长醉不复醒。
          古来圣贤皆寂寞，惟有饮者留其名。 陈王昔时宴平乐，斗酒十千恣欢谑。
          主人何为言少钱，径须沽取对君酌。
          五花马，千金裘，呼儿将出换美酒，与尔同销万古愁。
          君不见，黄河之水天上来，奔流到海不复回。
          君不见，高堂明镜悲白发，朝如青丝暮成雪。
          人生得意须尽欢，莫使金樽空对月。 天生我材必有用，千金散尽还复来。
          烹羊宰牛且为乐，会须一饮三百杯。 岑夫子，丹丘生，将进酒，杯莫停。
          与君歌一曲，请君为我倾耳听。 钟鼓馔玉不足贵，但愿长醉不复醒。
          古来圣贤皆寂寞，惟有饮者留其名。 陈王昔时宴平乐，斗酒十千恣欢谑。
          主人何为言少钱，径须沽取对君酌。
          五花马，千金裘，呼儿将出换美酒，与尔同销万古愁。
          君不见，黄河之水天上来，奔流到海不复回。
          君不见，高堂明镜悲白发，朝如青丝暮成雪。
          人生得意须尽欢，莫使金樽空对月。 天生我材必有用，千金散尽还复来。
          烹羊宰牛且为乐，会须一饮三百杯。 岑夫子，丹丘生，将进酒，杯莫停。
          与君歌一曲，请君为我倾耳听。 钟鼓馔玉不足贵，但愿长醉不复醒。
          古来圣贤皆寂寞，惟有饮者留其名。 陈王昔时宴平乐，斗酒十千恣欢谑。
          主人何为言少钱，径须沽取对君酌。
          五花马，千金裘，呼儿将出换美酒，与尔同销万古愁。
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "@/components/Banner";

export default {
  data() {
    return {
      sty: {
        // backgroundImage: "url(" + require("@/assets/home/banner1.jpg") + ")",
      },
      showInfo: {},
    };
  },
  components: {
    Banner,
  },
  mounted() {
    this.showInfo = JSON.parse(this.$route.query.showData);
  },
  methods: {
    getImgUrl(icon) {
      //展示图片
      return require(`@/assets/del/${icon}.png`);
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 1000px;
  background-color: #efefef;
  div {
    display: flex;
    flex-direction: row;
    margin-top: 30px;
    font-size: 22px;
    justify-content: center;

    div {
      padding: 0;
      width: 600px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      margin-left: 20px;
      font-size: 14px;
      font-weight: 100;
      margin-top: 20px;
      p {
        text-align: left;
        font-size: 22px;
        color: #409eff;
        font-weight: 600;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
